<template>
  <div>
    <div class="page-wrapper">
      <p class="title">预订须知：</p>
      <p class="content">1、皇家行前订仅为游轮上的商品、服务和活动等（以下统称为“产品”）的展示和下单平台，产品及其收款等均由游轮公司负责，所有预订订单费用将于乘客登船后自动从预订支付人（定义如下）的船卡中扣除。</p>
      <p class="content">2、皇家行前订仅适用于指定的“皇家加勒比国际游轮”中国母港航次，具体以网站实时信息为准。乘客需根据船票预订信息进入皇家行前订预订产品，每艘游轮每个航次上的产品都会有所不同，乘客仅可选择与其预订航次相对应的产品进行预订。</p>
      <p class="content">3、皇家行前订的产品价格和优惠仅适用于行前订；乘客于登船后进行的预订，以游轮上的实际售价为准。</p>
      <p class="content">4、皇家行前订的产品价格和优惠会不定期进行调整，调整一般不会影响既有预订；但如修改预订订单，则预订产品的价格将以预订订单修改时本网站的实时价格和优惠为准，可能会导致原预订时享受的价格和优惠不再适用。</p>
      <p class="content">5、部分产品对于乘客参与或使用有一定的限制条件（如年龄、身高、身体状况等），预订前请务必仔细阅读产品详情页面，不符合条件的乘客将会被拒绝参与或使用，且不退款或更换。</p>
      <p class="content">6、乘客登船后未按时参与或使用产品的，均视为自动放弃已预订的产品，不予退款或更换。</p>
      <p class="content">7、预订支付人信息修改（如姓名、出生年月等）或预订支付人未登船会导致预订订单被自动取消，该情况下，乘客应于开航日前48小时前自行登录皇家行前订更换预订支付人，若有疑问，请拨打400-820-3187（香港地区乘客请拨打852-6969-0717）咨询专属客服。</p>
      <p class="content">8、产品的具体参与或使用方式请见产品详情页面，请乘客携带船卡依照详情指示方式参与或使用产品。</p>
      <p class="content">9、岸上观光产品：</p>
      <ul class="content" style="margin-left:14px;">
          <li>（1）精品游行程的最低成团人数为38人，如未能达到最低成团人数，将于开航日前两周通知乘客；</li>
          <li>（2）本网站提供的岸上观光产品的行程与时长等信息仅供参考，景点游览次序、停留时间等会因不可抗力、当地客流量和交通等原因有所调整，具体以地接社实际接待为准；</li>
          <li>（3）岸上观光产品的具体集合时间、地点以及线路安排等信息将通过信件的方式直接放置于乘客的舱房内，乘客需于登船后自行查看舱房内的信件通知，及时获得有关信息，并按照规定的时间和地点集合。逾期不予等候、退款或更换，请乘客务必按时出席。</li>
          <li>（4）目的地产品及行程可能因相关政府政策及/或保护公共健康安全之相关要求而取消、变更或调整。</li>
          <li>（5）关于岸上观光产品的咨询、预订和修改，您可以拨打400-820-3187和皇家加勒比游轮度假专家联系。</li>
      </ul>
      <p class="content">10、定义：</p>
      <ul class="content" style="margin-left:14px;">
          <li>（1）预订支付人：即行前订预订订单的实际支付人，乘客在预订过程中可选择自己或同舱房其他乘客作为预订支付人，未选择的，默认为船票订单上的第一位乘客，登船后预订订单费用将自动从预订支付人的船卡中扣除。</li>
          <li>（2）划线价：即游轮公司根据市场情况制定的建议零售价，并非中国法律法规所定义之“原价”，且可能由游轮公司不时调整。除特别说明外，所有的立减、半价、折扣等优惠活动，均以划线价为计算基础。</li>
      </ul>
      <p class="title">取消及修改：</p>
      <p class="content">1.预订订单的修改或取消，仅可于开航日前48小时前进行。预订订单修改请登录皇家行前订自行操作，订单取消请拨打400-820-3187（香港地区乘客请拨打852-6969-0717）由专属客服协助操作。</p>
      <p class="content">2.乘客登船后未按时参与或使用产品的，均视为自动放弃已预订的产品，不予退款或更换。</p>
      <p class="content">3.部分产品会受天气、开航时间、航线变更、公共卫生安全事件、政府政策或管控措施等影响而需取消或变更，此情况下产品取消的，工作人员将会告知乘客取消事宜，则未登轮乘客将自动取消预订，已登轮并完成预订订单支付的乘客将全额退款；产品变更的，工作人员将会告知乘客变更方案，乘客可选择接受或不接受；如接受产品变更方案，工作人员将协助乘客重新安排活动时间。如不接受方案，未登轮乘客将取消预订，已登轮并完成预订订单支付的乘客将全额退款。</p>
      <p class="content">4.如乘客预订的航次因不可抗力、公共卫生安全事件、政府政策或管控措施或游轮公司原因被取消，则对应的行前订预订订单自动取消，不收取取消或预订费用；如因前述原因导致乘客变更航次的，乘客可以选择保留原预订（且继续适用原预订的价格和优惠）至新的航次上，但前提是新航次上有该产品且库存充足；乘客希望保留预订的，请拨打400-820-3187（香港地区乘客请拨打852-6969-0717）由专属客服协助操作。</p>
      <p class="content">5.如乘客因其个人原因取消整个舱房的船票预订的，则对应的行前订订单自动取消，不收取取消或预订费用；乘客取消后重新预订船票的，需以新船票预订信息登入行前订重新进行预订。</p>
      <p class="content">6.皇家行前订的产品价格和优惠仅适用于行前订；乘客于登船后进行的预订，以游轮上的实际售价为准。</p>
      <p class="content">7.皇家行前订的产品价格和优惠会不定期进行调整，调整一般不会影响既有预订；但如修改预订订单，则预订产品的价格将以预订订单修改时本网站的实时价格和优惠为准，可能会导致原预订时享受的价格和优惠不再适用。</p>
      <p class="content">8.预订支付人信息修改（如姓名、出生年月等）或预订支付人未登船会导致预订订单被自动取消，该情况下，乘客应于开航日前48小时前自行登录皇家行前订更换预订支付人，若有疑问，请拨打400-820-3187（香港地区乘客请拨打852-6969-0717）咨询专属客服。</p>
      <p class="content">9.划线价：即游轮公司根据市场情况制定的建议零售价，并非中国法律法规所定义之“原价”，且可能由游轮公司不时调整。除特别说明外，所有的立减、半价、折扣等优惠活动，均以划线价为计算基础。</p>
      <p class="content">10.预订支付人：即行前订预订订单的实际支付人，乘客在预订过程中可选择自己或同舱房其他乘客作为预订支付人，未选择的，默认为船票订单上的第一位乘客，登船后预订订单费用将自动从预订支付人的船卡中扣除。</p>
      <p class="content">**皇家加勒比國際遊輪在法律允許範圍內對本活動保留解釋權。</p>
    </div>
    <base-footer />
  </div>
</template>

<script>
import BaseFooter from '@/components/BaseFooter'
export default {
  name: 'PageTerms',

  components: {
    BaseFooter
  }
}
</script>

<style lang="less" scoped>
.page-wrapper {
  padding: 0 50px;
  overflow: hidden;
  background-color: #fff;
}
.title {
  margin-top: 30px;
  font-size: 30px;
  color: #333;
  line-height: 66px;
}
.content {
  margin-bottom: 38px;
  font-size: 24px;
  line-height: 38px;
  color: #999;
}
</style>
